import axios from "axios";
import {
  getAccessToken,
  getRefreshToken,
  setAuthCookies,
  removeAuthCookies,
} from "./cookies";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URI,
  headers: {
    "Content-type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor - shows toast notifications and handles token refresh
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const status = error.response?.status;

    if (status !== 401) {
      // 401 - Unauthorized, indicates accessToken has expired,
      // otherwise return error to be passed to API call implementation
      return Promise.reject(error);
    }

    const refreshToken = getRefreshToken();

    if (!refreshToken) {
      if (window.location.pathname !== "/signin") {
        removeAuthCookies();
        window.location.href = "/signin";
      }
      return Promise.reject(error);
    }
    if (
      refreshToken &&
      ["/signin", "/signup"].includes(window.location.pathname)
    ) {
      removeAuthCookies();
      return;
    }

    const getNewTokens = async () => {
      try {
        return await axios.post(
          `${process.env.REACT_APP_API_URI}/users/refresh-token`,
          {
            refreshToken,
          },
          { withCredentials: true },
        );
      } catch (err) {
        return null;
      }
    };

    const newToken = await getNewTokens();
    if (!newToken || newToken.status !== 200) {
      window.location.href = "/signup";
      return;
    }

    // Use the namespaced helper so the refreshed tokens live under this
    // app's cookie namespace (see cookies.js) and don't collide with the
    // other app's tokens when both run in the same browser.
    setAuthCookies(
      newToken.data.data.accessToken,
      newToken.data.data.refreshToken,
    );
    console.log("Error Config: ", error.config);
    return instance(error.config);
  },
);

export default instance;
